import * as React from 'react';
import { Exhibit } from '../../../../interfaces/models';
import { Entity } from '../EntityResults/Result';
import Table from '../../Table';
import { TrashIcon } from '@heroicons/react/24/outline';

interface RelatedExhibitsProps {
  exhibits: Exhibit[];
  onRemove: (entity: Entity) => void;
}

const RelatedExhibits: React.FC<RelatedExhibitsProps> = ({
  exhibits,
  onRemove,
}) => {
  const onRemoveQuiz = (
    e: React.MouseEvent<HTMLButtonElement>,
    exhibit: Exhibit
  ): void => {
    e.preventDefault();
    onRemove(exhibit);
  };

  if (exhibits.length > 0) {
    return (
      <>
        <h3 className="medium-title mb-2 mt-3">Exhibits</h3>
        <Table headings={['ID', 'Title', 'Actions']}>
          {exhibits.map((exhibit) => (
            <tr
              key={`${exhibit.__typename}-${exhibit.id}`}
              className="hover:bg-gray-50"
            >
              <td className="w-1 px-6 py-2 whitespace-nowrap">{exhibit.id}</td>
              <td className="px-6 py-2 whitespace-nowrap">{exhibit.title}</td>
              <td className="w-2 px-6 py-2 whitespace-nowrap">
                <button
                  className="btn py-1"
                  onClick={(e) => onRemoveQuiz(e, exhibit)}
                >
                  <TrashIcon className="h-5 w-5" />
                </button>
              </td>
            </tr>
          ))}
        </Table>
      </>
    );
  } else {
    return null;
  }
};

export default RelatedExhibits;
